import classNames from "classnames";

type InputType = "text" | "number" | "tel" | "password" | "radio";

interface InputProps {
  label?: string;
  name: string;
  radioLabel?: string;
  placeholder?: string;
  type: InputType;
  value: string;
  errorMsg?: string;
  isRequired?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Input = (props: InputProps) => {
  const {
    label,
    name,
    placeholder,
    type = "text",
    radioLabel,
    value,
    onChange,
    errorMsg,
    isRequired,
  } = props;
  return (
    <div>
      {label && (
        <label className="field-label" htmlFor={name}>
          {label}
          <span className="required-field">{isRequired && "*"}</span>
        </label>
      )}
      <label
        className={classNames(type === "radio" && "radio-button-field w-radio")}
      >
        <input
          value={value}
          onChange={onChange}
          type={type}
          className={classNames(
            type !== "radio" ? "w-input" : "w-form-formradioinput w-radio-input"
          )}
          max="256"
          name={name}
          data-name={name}
          placeholder={placeholder || ""}
          id={name}
        />
        {type === "radio" && (
          <span className="radio-button-label w-form-label">{radioLabel}</span>
        )}
      </label>
      {errorMsg && <span className="error_text">{errorMsg}</span>}
    </div>
  );
};

export default Input;
